/**
 * ai.ask - gather user intent and produce a structured intent object
 * Called from agent Vuex action with helpers: {dispatch, commit, rootState}
 * args: { userPrompt, contextData, introspection, currentContext }
 * Returns a string (raw AI response) or parsed object depending on call flow
 */
module.exports = async function ask(helpers = {}, args = {}) {
  const { dispatch, rootState } = helpers || {}
  const { userPrompt = '', contextData = {}, introspection = {}, currentContext = [] } = args || {}

  // Try to get a fresh introspection from agent if available
  let liveIntrospection = introspection
  try {
    if (dispatch) {
      const res = await dispatch('agent/introspect', {}, { root: true })
      if (res) liveIntrospection = res
    }
  } catch (e) {
    // ignore and use provided introspection
  }

  // Try to capture view state
  let viewScope = null
  try {
    const view = require('./viewstate')
    viewScope = await view(helpers, { rootState })
  } catch (e) {
    // ignore
  }

  // Build a concise prompt for the intent phase
  const prompt = `You are an assistant that extracts intent and options for a web UI workflow.\n\nUser Request: "${userPrompt}"\n\nSystem Overview: ${contextData.system_data?.overview || ''}\n\nAvailable components: ${Object.keys(contextData.descriptions?.components || {}).slice(0,20).join(', ')}\n\nAvailable actions: ${liveIntrospection.dispatchActions?.slice(0,10).map(a=>a.name).join(', ')}\n\nCurrent context: ${JSON.stringify(currentContext || [], null,2)}\n\nDetected view_scope: ${JSON.stringify(viewScope || null, null, 2)}\n\nReturn ONLY strict JSON with keys: intent, response, capabilities, recommended_components, recommended_functions, recommended_actions, component_structure, introspection_instructions.`

  // Use callAI helper when available
  if (dispatch) {
    const aiResponse = await dispatch('callAI', { prompt })
    return aiResponse
  }

  // Fallback: return a basic JSON string
  return JSON.stringify({ intent: userPrompt, response: userPrompt, capabilities: [], recommended_components: [], recommended_functions: [], recommended_actions: [], component_structure: {} })
}
